import classToggle from '../helpers/class-toggle';
import { Splide } from '@splidejs/splide';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import { setScrolled } from './../helpers/events';

export default () => {

	const sections = document.querySelectorAll('.prod');
	const gallery = document.querySelector('.product-main__gallery .splide');
	const slides = document.querySelectorAll('.product-main__slide');
	const counter = document.querySelector('.product-main__pagination-current');
	let currentSlide;

	sections.forEach(function(section) {
		const slider = section.querySelector('.splide');

		if (slider) {
			const splide = new Splide(slider, {
				focus  : 'center',
				gap: 12,
				speed: 500,
				arrows: false,
				pagination: false,
				type: 'loop',
				autoWidth: true,
				mediaQuery: 'min',
				drag: 'free',
				snap: true,
				breakpoints: {
					744: {
						gap: 20
					},
					1024: {
						destroy: true,
					},
				}
			}).mount();

			splide.on('active', () => {
				if (window.innerWidth > 999) return;
				counter.innerText = splide.index + 1;
			});
		}
	});

	if (gallery && counter) {
		let st = ScrollTrigger.create({
			trigger: gallery,
			start: "top 1%",
			end: "bottom bottom",
			//markers: {startColor: "green", endColor: "red", fontSize: "12px"},
			scrub: true,
			onUpdate: (self) => {
				if (window.innerWidth < 1000) return;

				let val = Math.round(self.progress*(slides.length - 1)) + 1;

				if (val !== currentSlide) {
					currentSlide = val;
					counter.innerText = currentSlide;
				}
			}
		});
	}


	// size buttons
	const ACTIVE_CLASS = 'size-select__item--active';
	const sizeButtons = document.querySelectorAll('.size-select__item');
	const addBtns = document.querySelectorAll('.js-add-to-bag, .js-add-to-wl');
	const sizeLabels = document.querySelectorAll('.js-size');

	sizeButtons.forEach(function(b, index) {
		b.addEventListener('click', (e) => {
			e.preventDefault();
			if (!b.classList.contains(ACTIVE_CLASS) && !b.classList.contains('size-select__item--disabled')) {
				// classToggle(sizeButtons, b, ACTIVE_CLASS);

				const id = b.dataset.id;
				console.log({id});

				sizeButtons.forEach(function(sizeButton) {

					if (sizeButton.dataset.id == id) {
						sizeButton.classList.add(ACTIVE_CLASS);
					} else {
						sizeButton.classList.remove(ACTIVE_CLASS);
					}
				});


				addBtns.forEach(function(btn) {
					btn.classList.remove('btn--disabled');
					btn.dataset.id = b.dataset.id;

					sizeLabels.forEach(function(label) {
						label.classList.remove('size__btn-label--light');
						label.innerText = "Size: " + b.querySelector('span').innerText;
					});
				});

				// let toggleButtons = document.querySelectorAll('.js-wishlist-toggle');
				// toggleButtons.forEach(function(toggleButton) {
				// 	toggleButton.dataset.vid = b.dataset.id;
				// });
			}
		});
	});

	// get variant id from URL and apply as active size
	const url = window.location.href;
	const variantId = url.split('variant=')[1];

	if (variantId) {
		const sizeBtn = document.querySelector(`.size-select__item[data-id="${variantId}"]`);
		if (sizeBtn) {
			sizeBtn.click();
		}
	}


	// sticky button show/hide
	const buyBtn = document.querySelector('.product-main__btn-add');
	const btnSticky = document.querySelector('.add-sticky');
	const trigger = document.querySelector('.product-main__row');
	const triggerBottom = document.querySelector('main');

	if (buyBtn && btnSticky) {
		setScrolled(() => {
			if (trigger.getBoundingClientRect().bottom > window.innerHeight / 4 ||
			triggerBottom.getBoundingClientRect().bottom < window.innerHeight) {
				btnSticky.classList.remove('is-visible');
			}
			else {
				btnSticky.classList.add('is-visible');
			}
		});
	}


}